export const TAG = {
  GET: 'GET_TAG',
  GET_SUCCESS: 'GET_TAG_SUCCESS',
  GET_FAILURE: 'GET_TAG_FAILURE',
}
